import { Box } from '@mui/material';
import { useAttendeeStatus } from 'amazon-chime-sdk-component-library-react';
import { BaseProps } from 'amazon-chime-sdk-component-library-react/lib/components/ui/Base';

import MicrophoneIcon from './icons/microphoneIcon';

export interface NameplateProps extends BaseProps {
  attendeeID: string;
  name: string;
}

function Nameplate({ name, attendeeID }: NameplateProps) {
  const { muted } = useAttendeeStatus(attendeeID);

  return (
    <Box
      sx={{
        backdropFilter: 'blur(2px)',
        bottom: '1rem',
        left: '1rem',
        padding: '8px 16px',
        position: 'absolute',
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '12px',
        flexShrink: 0,
        borderRadius: '6px',
        background: 'rgba(0, 0, 0, 0.60)',
      }}
    >
      <Box
        sx={{
          color: (theme) => theme.palette.neutralBlackBg[50],
          fontSize: '14px',
          fontStyle: 'normal',
          fontWeight: '400',
          minHeight: '22px',
        }}
      >
        {name}
      </Box>
      {muted && (
        <Box sx={{ width: '22px', height: '22px' }}>
          <MicrophoneIcon muted={muted} />
        </Box>
      )}
    </Box>
  );
}

export default Nameplate;
